import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import produce, { immerable } from 'immer';
import { Map, OrderedSet, Set } from 'immutable';

import { SubscriptionItemEntity } from './subscription-item.entity';

export type ISubscriptionListExtra = IListColumnConfig<SubscriptionItemEntity>;

interface ISubscriptionListEntity extends IListAttrs<SubscriptionItemEntity> {
	availableColumns: Map<string, ISubscriptionListExtra>;
	totalItems: number;
}

const entityDefaults: ISubscriptionListEntity = {
	elements: Map(),
	availableColumns: Map(),
	totalItems: 0,
};

export class SubscriptionListEntity
	implements
		ISubscriptionListEntity,
		IListOperations<SubscriptionListEntity, SubscriptionItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;
	public totalItems = entityDefaults.totalItems;

	public static build(
		availableCols: Array<ISubscriptionListExtra>
	): SubscriptionListEntity {
		const instance = new SubscriptionListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, ISubscriptionListExtra]>());
		instance.availableColumns = Map(cols);
		return instance;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<SubscriptionItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(
		elems: Map<string, SubscriptionItemEntity>
	): SubscriptionListEntity {
		return produce(this, (draft: SubscriptionListEntity) => {
			draft.elements = elems;
		});
	}

	public setTotalItems(total: number): SubscriptionListEntity {
		return produce(this, (draft: SubscriptionListEntity) => {
			draft.totalItems = total;
		});
	}

	public extractUniqTags(...startValues: Array<string>): Set<string> {
		const allTags = this.elements
			.reduce((acc, item) => {
				if (!item.tags) {
					return acc;
				}
				return Set([
					...acc.toArray(),
					...item.tags
						.toList()
						.toArray()
						.map((l) => l.label),
				]);
			}, Set<string>())
			.sort((a, b) => a.localeCompare(b));

		return OrderedSet<string>([...startValues, ...allTags]);
	}
}
